<template>
    <div >
        <div class="page-layout">
            <div class="topbar-height">
                <Header></Header>
            </div>
            <div v-if="isHome">
                <slot></slot>
            </div>
            <div v-else-if="isSearchList">
                <div class="container-search">
                    <Breadcrumb
                        :pageName="$route.name"
                        :subPageName="subPageName"
                        searchList
                        @updateSubPageName="updateSubPageName()"
                    />
                    <slot></slot>
                </div>
            </div>
            <div class="bds-container" v-else>
                <div class="content-layout" v-if="isSideMenu && !isMyAccount">
                    <div class="sidemenu">
                        <SideMenu></SideMenu>
                    </div>
                    <div v-if="isMyProfle" class="content-wrapper">
                        <div class="header">
                            <slot name="header"></slot>
                            <Breadcrumb
                                :pageName="$route.name"
                                :subPageName="subPageName"
                                @updateSubPageName="updateSubPageName()"
                            />
                            <slot></slot>
                        </div>
                    </div>
                    <div v-else class="content-wrapper">
                        <div class="header">
                            <!-- <img @click="clickBack()" class="icon-back" src="@/assets/icon/icon-back.svg" alt=""> -->
                            <img @click="clickBack()" class="icon-back" src="@/assets/icon/ic-back-mobile.svg" alt="">
                            <slot name="header">
                            </slot>
                            <div class="mock-div"></div>
                            <Breadcrumb
                                :pageName="$route.name"
                                :subPageName="subPageName"
                                @updateSubPageName="updateSubPageName()"
                            />
                            <!-- <div class="divider"></div> -->
                        </div>
                        <slot></slot>
                    </div>
                </div>
                <div v-else>
                    <div v-if="isMyProfle" class="content-wrapper">
                        <div class="header">
                            <slot name="header"></slot>
                            <Breadcrumb v-if="isBreadcrumb"
                                :pageName="$route.name"
                                :subPageName="subPageName"
                                @updateSubPageName="updateSubPageName()"
                            />
                            <slot></slot>
                        </div>
                    </div>
                    <div v-else-if="isMyAccount" class="content-wrapper">
                        <div class="header">
                            <slot name="header"></slot>
                            <slot></slot>
                        </div>
                    </div>
                    <div v-else class="content-wrapper">
                        <div class="header">
                            <img @click="clickBack()" class="icon-back" src="@/assets/icon/icon-back.svg" alt="">
                            <slot name="header"></slot>
                            <div class="mock-div"></div>
                            <Breadcrumb v-if="isBreadcrumb"
                                :pageName="$route.name"
                                :subPageName="subPageName"
                                @updateSubPageName="updateSubPageName()"
                                :isCampaign="isCampaign"
                                :isFlashSale="isFlashSale"
                            />
                            <!-- <div class="divider"></div> -->
                        </div>
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
import SideMenu from '../SideMenu/SideMenu.vue';
import Breadcrumb from '../component/Breadcrumb/Breadcrumb.vue';
import Header from "../Header/Header.vue";
import Footer from "../Footer/Footer.vue";
import ModalMixin from '@/mixin/ModalMixin';
export default {
    name: 'MainPage',
    mixins: [ModalMixin],
    props: {
        customClass: [String,Array],
        subPageName: { type: String, default: null },
        isMyProfle: { type: Boolean, default: false },
        isMyAccount: { type: Boolean, default: false },
        isSideMenu: { type: Boolean, default: true },
        isBreadcrumb: { type: Boolean, default: true },
        isHome: { type: Boolean, default: false },
        isSearchList: { type: Boolean, default: false },
        isCampaign: { type: Boolean, default: false },
        isFlashSale: { type: Boolean, default: false },
    },
    data: function() {
        return {
            blobConfig: Account.getCacheBlob(),
            query: Account.getCacheQuery(),
            lbl: Locale.getLbl(),

            busTopbar: new Vue(),
        }
    },
    components: {
        SideMenu,
        Breadcrumb,
        Header,
        Footer
    },
    created: function() {},
    mounted: function() {
        this.scrollToTop();
    },
    methods: {
        initLanding: async function () {
            this.blobConfig.query = this.query;
        },
        updateSubPageName: function () {
            this.$emit('updateSubPageName')
        },
        clickBack: function () {
            this.$emit('clickBack')
        },
        updateCart: function () {
            this.busTopbar.$emit('updateCart', {});
        },
        updateDashBoard: function () {
            this.busDashboard.$emit('noFlashSale', {});
        },
        scrollToTop: function() {
            window.scrollTo(0,0);
        }
    }
}
</script>
<style lang="scss" scoped>
     @import '@/style/base/base.scss';
     @import "./MainPage.scss";
     .bds-container {
        padding: 24px 0px;
        @include min-desktop {
            max-width: $max-container-desktop;
            margin: auto;
        }
    }
</style>
